import { noop } from 'lodash';
import { ComponentType, lazy } from 'react';

import {
    commitVersionAndReload,
    fetchDeployedVersion,
    getStoredAppVersion,
    hasAlreadyReloadedFor,
    refreshDocumentCache,
} from './AppVersionHelper';

type ComponentModule<T> = { default: T };
type ComponentLoader<T> = () => Promise<ComponentModule<T>>;

export async function loadWithVersionRecovery<T>(loader: ComponentLoader<T>): Promise<ComponentModule<T>> {
    try {
        return await loader();
    } catch (error) {
        const deployedVersion = await fetchDeployedVersion().catch((): string | null => null);

        if (!deployedVersion || deployedVersion === getStoredAppVersion() || hasAlreadyReloadedFor(deployedVersion)) {
            throw error;
        }

        if (!(await refreshDocumentCache())) {
            throw error;
        }

        commitVersionAndReload(deployedVersion);

        return new Promise<ComponentModule<T>>(noop);
    }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function lazyWithRetry<T extends ComponentType<any>>(loader: ComponentLoader<T>) {
    return lazy(() => loadWithVersionRecovery(loader));
}
